import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { getErrorMessage } from "helpers";
import { merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse, UWDecisions, uwDecisionType } from "types";

const useUpdateApprovalMutation = () => {
	const dispatch = useDispatch();
	const history = useHistory();

	return useMutation(
		({
			data,
			applicationId,
		}: {
			data: uwDecisionType;
			applicationId: string;
		}) => {
			const decision = {
				decision: data?.decision?.name,
				title: data?.title,
				note: data?.note,
			};

			return merchantInfoService.updateUnderwritingApproval({
				applicationId,
				decision,
			});
		},
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess(_result, { applicationId, data }) {
				if (data?.decision?.name === UWDecisions.Approved.name) {
					history.push(`/underwriting/historical/${applicationId}`);
				} else {
					history.push(
						`/underwriting/concurrence-conditions/${applicationId}`,
					);
				}
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUpdateApprovalMutation;
